import '@/utils/handle-env';

import '@/utils/handle-public-path';

import '@/utils/force-main';

import '@/utils/bootstrap/axe';

import theme from '@/assets/theme';
import coreComponents from '@/components/aem-core';
import atomicComponents from '@/components/atomic';
import IconsSprite from '@/components/atomic/molecules/data-display/icons-sprite';
import AuthoringHelper from '@/utils/authoring';
import Bootstrap from '@/utils/bootstrap';
import EntryPointsHelper from '@/utils/entry-points-helper';
import AfterEntryComponent from '@/utils/entry/after';
import BeforeEntryComponent from '@/utils/entry/before';
import { ComponentsManager } from '@multitenancy-spa/components-manager/esm/services/components-manager';
import { EnvVarsService } from '@multitenancy-spa/env-vars-service/esm/services/env-vars-service';

const start = async () => {
	try {
		EntryPointsHelper.init();

		const componentsManager = new ComponentsManager({
			appId: EnvVarsService.getVar('VITE_APP_ID'),
			componentsToBeMapped: [...coreComponents, ...atomicComponents],
		});

		const bootstrap = new Bootstrap({
			BeforeEntryComponent: <BeforeEntryComponent />,
			AfterEntryComponent: AuthoringHelper.isInEditor ? (
				<IconsSprite />
			) : (
				<AfterEntryComponent />
			),
			componentsManager,
			theme,
		});

		await bootstrap.init();
	} catch {
		//
	}
};

start();
